var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEngineroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(-313.29 -2636.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(-9.284 -0.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(425.02 2700.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436-2",
    "data-name": "Group 436",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M93.515,513.09a3.251,3.251,0,0,0,.815-4.707c-1.9-2.987-6.155-10.319-6.155-10.319s-.815-1.629-4.345-3.168-4.345-2.263-6.065-5.159c-.091,0-1.358-3.621-3.983-2.172s-6.427,2.353-4.888,5.431,2.9,4.073,2.444,6.608-2.172,6.065,0,9.5,6.427,10.5,6.427,10.5,1.629,1.991,4.8,0S93.515,513.09,93.515,513.09Z",
    transform: "translate(-45.735 -478.734)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M154.017,618s-.272,1.991-8.237,4.888-8.78,5.793-8.78,5.793",
    transform: "translate(-112.03 -599.031)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M291.388,408.393s-1.81-1.448,0-2.534,2.806-1.629,2.806-1.629l-1.086-1.72-6.608-1.9s-1-1-4.526,1.086S276,405.406,276,405.406l2.716,4.526,4.435-2.534,3.349,3.983Z",
    transform: "translate(-262.795 -400.371)",
    fill: "none",
    stroke: "#fffbfb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M400.8,481s-.362,5.974-3.8,9.323",
    transform: "translate(-380.678 -472.984)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M0,1.086,3.259,0",
    transform: "translate(9.26 8.811) rotate(-171)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M0,1.034,2.924,0",
    transform: "translate(10.457 10.856) rotate(177)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M0,1.034,2.924,0",
    transform: "matrix(-0.875, 0.485, -0.485, -0.875, 11.616, 12.528)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M0,1.086,3.259,0",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 3.257, 10.576)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M0,1.119,3.321,0",
    transform: "translate(5.088 13.665) rotate(173)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M0,1.119,3.321,0",
    transform: "translate(7.301 16.499) rotate(161)",
    fill: "none",
    stroke: "#fffbfb",
    strokeLinecap: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "download1",
    transform: "translate(359.574 2695.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M250.577,407.8a15.325,15.325,0,0,0-15.043,0,15.047,15.047,0,1,0,15.043,0Zm-.211,23.2-1.214-2.1-2.171,1.253,1.211,2.1a12.511,12.511,0,0,1-3.886,1.013v-2.4H241.8v2.4a12.543,12.543,0,0,1-3.886-1.013l1.211-2.1-2.171-1.253-1.214,2.1a12.453,12.453,0,0,1-2.851-2.851l2.1-1.214-1.253-2.171-2.1,1.214a12.5,12.5,0,0,1-1.037-3.889h2.426V419.58H230.6a12.459,12.459,0,0,1,1.037-3.889l2.1,1.214,1.253-2.171-2.1-1.214a12.439,12.439,0,0,1,2.851-2.851l1.214,2.1,2.171-1.253-1.214-2.1a12.491,12.491,0,0,1,3.889-1.037V410.8h2.507v-2.426a12.461,12.461,0,0,1,3.889,1.037l-1.214,2.1,2.171,1.253,1.214-2.1a12.454,12.454,0,0,1,2.851,2.851l-2.1,1.214,1.253,2.171,2.1-1.214a12.5,12.5,0,0,1,1.037,3.889h-2.426v2.507h2.426a12.461,12.461,0,0,1-1.037,3.889l-2.1-1.214-1.253,2.171,2.1,1.214A12.454,12.454,0,0,1,250.365,431Z",
    transform: "translate(-214.219 -365.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M286.068,457.4a6.268,6.268,0,1,0,6.268,6.268A6.275,6.275,0,0,0,286.068,457.4Zm0,10.029a3.761,3.761,0,1,1,3.761-3.761A3.766,3.766,0,0,1,286.068,467.429Z",
    transform: "translate(-257.236 -408.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M309.4,487h2.507v2.507H309.4Z",
    transform: "translate(-281.822 -433.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M223.957,212.655a3.748,3.748,0,0,0-2.131-3.4v-3.068a11.116,11.116,0,0,0-.83-4.216,11.3,11.3,0,0,0-8.676-6.925l-13.311-2.129-2.058-6.172,8.306-5.685a27.085,27.085,0,0,1,15.314-4.734v-2.507a29.6,29.6,0,0,0-16.731,5.171l-15.778,10.8-18.889-17.9a11.189,11.189,0,0,0-7.759-3.092H146.611v58.92h11.283v-3.761a17.551,17.551,0,0,1,34.517-4.5,17.316,17.316,0,0,1,.584,4.5v3.761h28.832a2.518,2.518,0,0,0,2.507-2.545Zm-4.947-8.75a8.538,8.538,0,0,1,.308,2.282v2.485l-11.283-2.051V203.9ZM196.218,192.47l-6.186-.989,4.767-3.263Zm-34.8-21.16a8.693,8.693,0,0,1,6.032,2.4l18.632,17.654h-3.951l-4.609-3.456-12.26-12.26a6.305,6.305,0,0,0-4.432-1.834H149.117V171.31Zm4,18.178a4.3,4.3,0,0,0,.052.627H149.116v-13.79h11.709a3.793,3.793,0,0,1,2.662,1.1l7.676,7.676H169.8a4.392,4.392,0,0,0-4.387,4.387Zm4.387-1.881h3.869l2.14,2.14,2.152,1.621H169.8a1.889,1.889,0,0,1-1.331-.548,1.514,1.514,0,0,1-.175-.208,1.881,1.881,0,0,1,1.507-3.005Zm-14.416,37.608h-6.268V220.2h6.629a20.123,20.123,0,0,0-.361,3.761Zm1.018-7.522h-7.286V192.621H166.73a4.415,4.415,0,0,0,3.07,1.253h10.625a31.433,31.433,0,0,1-2.135,10.253,20.568,20.568,0,0,0-2.849-.224,20.1,20.1,0,0,0-19.04,13.79Zm24.383-13.069a33.9,33.9,0,0,0,2.146-10.75h6.2l22.793,3.646a8.788,8.788,0,0,1,5.956,3.876H205.529v7.313l14.854,2.7a1.263,1.263,0,0,1,1.068,1.28l.149,5H194.491a20.211,20.211,0,0,0-13.7-13.069Zm14.714,20.59v-1.253a20.148,20.148,0,0,0-.355-3.761h26.53l.151,5.014Z",
    transform: "translate(-146.611 -168.803)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineroom);
export default __webpack_public_path__ + "static/media/engineroom.bf0bbe2ff15095b44ddd55f7d5bec1d2.svg";
export { ForwardRef as ReactComponent };